import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Article } from '@freelancer/datastore/collections';
import { Feature } from '@freelancer/feature-flags';
import { LinkColor, LinkUnderline, LinkWeight } from '@freelancer/ui/link';
import { FontType, TextSize } from '@freelancer/ui/text';

@Component({
  selector: 'app-user-profile-articles-item',
  template: `
    <fl-link
      flTrackingLabel="UserProfileArticlesItemClick"
      [color]="LinkColor.DARK"
      [link]="article.seoUrl"
      [underline]="LinkUnderline.HOVER"
      [weight]="LinkWeight.BOLD"
    >
      {{ article.title }}
    </fl-link>
    <fl-bit class="ArticleInfoContainer">
      <fl-text i18n="Article category information">
        in
        <fl-link
          flTrackingLabel="UserProfileArticleCategoryClick"
          [color]="LinkColor.DARK"
          [link]="'/community/' + article.mainCategory.seoName"
        >
          {{ article.mainCategory.name }}
        </fl-link>
      </fl-text>
      <fl-text i18n="Article date created" [size]="TextSize.XXSMALL">
        {{ article.createTime | date }}
      </fl-text>
    </fl-bit>
  `,
  styleUrls: ['./user-profile-articles-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileArticlesItemComponent {
  Feature = Feature;
  TextSize = TextSize;
  FontType = FontType;
  LinkColor = LinkColor;
  LinkUnderline = LinkUnderline;
  LinkWeight = LinkWeight;

  @Input() article: Article;
}
